module.exports = __webpack_public_path__ + "gm992021/img/default-award.png?0e99d128";